(function (Sliders, $) {
  'use strict';

  var $dom = {};
  var prev = '<button class="slider-control slider-prev"><i class="fa fa-arrow-left"></i></button>';
  var next = '<button class="slider-control slider-next"><i class="fa fa-arrow-right"></i></button>';

  var homeSliderOptions = {
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    accessibility: false
  };

  var featuredCollectionSlider = {
    arrows: true,
    variableWidth: true,
    prevArrow: prev,
    nextArrow: next,
    slidesToShow: 3
  };

  var productSliderOptions = {
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    draggable: true,
    prevArrow: prev,
    nextArrow: next,
    responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    ]
  };

  var socialSliderOptions = {
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: false,
    draggable: false,
    prevArrow: prev,
    nextArrow: next,
    autoplay: true,
    autoplaySpeed: 5000,
    focusOnSelect: false
  };

  var featureSliderOptions = {
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
    draggable: true,
    centerMode: true,
    variableWidth: true,
    adaptiveHeight: true,
    prevArrow: prev,
    nextArrow: next,
    responsive: [
      {
        breakpoint: 740,
        settings: {
        }
      }
    ]
  };

  var cacheDom = function () {
    $dom.productImagesSlider = $('slider.product-images');
    $dom.homepageSlider = $('.homepage-slider__wrap');
    $dom.socialSlider = $('.social-content');
    $dom.featuredCollectionSlider = $('.js-featured-collection-slider');
    $dom.featuredImageSlider = $('.feature-image-slider-block');
  };

  var initSliders = function () {
    $dom.productImagesSlider.slick(productSliderOptions);
    $dom.homepageSlider.slick(homeSliderOptions);
    $dom.socialSlider.slick(socialSliderOptions);
    $dom.featuredCollectionSlider.slick(featuredCollectionSlider);
    $dom.featuredImageSlider.slick(featureSliderOptions);
  };

  var init = function () {
    cacheDom();
    initSliders();
  }

  Sliders.init = init;
}(window.Sliders = window.Sliders || {}, jQuery));
